import React, { Component } from "react";
import CreateInvoice from './CreateInvoice';
import invoiceService from '../../services/WebInvoiceService';
import ShopInvoiceForm from './ShopInvoiceForm';

export default class CreateShopInvoice extends Component {
    
    constructor(props) {
        super(props);
        this.state = { 
            initialState: this.createInitialState()
        }
    }

    createInitialState() {
        return  {
            customerId : this.props.match.params.customerId,
            companyPO : '',
            location: '',
            date : null,
            unit : '',
            vehicle : '',
            vin : '',
            serviceNotes : '',
            parts: [],
            paymentType: null,
            laborCharges : '',
            partsCharges : '',
            miscCharges : '',
            credits : '',
            postedToReceivables : '',
            paymentDate: null,
            invoiceTotal:'',
            referenceNumber: '',
            mileage: '',
            serviceTruckCharges: '',
            taxes: ''
        };
    }

    handleGenerateClick = async (invoice) => {
        await invoiceService.createShopInvoiceSync(invoice);        
        this.props.history.push({pathname:`/customer/${invoice.customerId}/shopinvoices`});
    }

    render() {
        return (<CreateInvoice initialState={this.state.initialState} handleGenerateClick={this.handleGenerateClick} form={ShopInvoiceForm}/>)
    }    
}